/** @jsxImportSource @emotion/react */
import { Box, Button, useTheme } from '@mui/material'
import { noRiskStories } from '@app/routes/RiskPage/RiskPage.styles'
import { selectedClientAtom } from '@app/state/clientsAtom'
import { storiesAtom } from '@app/state/storiesAtom'
import { useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'
import slugify from 'react-slugify'
import RiskStoriesLoading from './RiskStoriesListLoading'
import { RiskStoryCard } from './RiskStoryCard'
import { riskStoryContainer, storyListContainer, subNavbar } from './RiskStoryList.style'
import { Story } from '../types'
import { Add } from '@mui/icons-material'
import { userAtom } from '@app/hooks/useUserProfile'
import { UserRole } from '@app/types'

const RiskStoryList = () => {
  const theme = useTheme()
  const storiesData = useAtomValue(storiesAtom)
  const navigate = useNavigate()
  const clientDisplayName = useAtomValue(selectedClientAtom)?.display_name
  const { data: user } = useAtomValue(userAtom)
  const isStaff = user?.user_roles.includes(UserRole.STAFF) ?? false

  if (storiesData.isLoading) return <RiskStoriesLoading isError={false} numberOfItems={3} />
  if (storiesData.isError) return <RiskStoriesLoading isError={true} />

  const storiesList = storiesData?.data ?? []

  const handleStorySelect = (story: Story) => {
    const slug = slugify(story.title)
    navigate(`/app/risk/stories/${story.id}${slug ? `/${slug}` : ''}`)
  }

  const handleCreateStory = () => {
    navigate('/app/risk/explorer/story-builder')
  }

  if (storiesList.length === 0)
    return (
      <Box css={noRiskStories}>
        <img src="/images/icons/docicon.svg" width={250} height={200} />
        <h2>No Risk Stories yet</h2>
        {/* TODO: @kjpluck Kev where did you get this 493 from?? this is a genuine curiosity */}
        <Box style={{ fontSize: 18, maxWidth: 400, textAlign: 'center' }}>
          Contact your Advisor to start creating a Risk Story library for {clientDisplayName}.
        </Box>
        {isStaff && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
              variant="contained"
              startIcon={<Add />}
              onClick={handleCreateStory}
              size="large"
            >
              Create Story
            </Button>
          </Box>
        )}
        <Box style={{ height: 150 }}>
          {/*For whatever reason it wasn't centring vertically!! This helps.*/}
        </Box>{' '}
      </Box>
    )

  return (
    <Box css={riskStoryContainer} id="storyPageContainer">
      <Box css={subNavbar}>
        <div />
        <div>
          <h1>Risk stories</h1>
          <p>Here are the risk stories created by your organisation.</p>
        </div>
        {isStaff && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pr: 3 }}>
            <Button variant="contained" startIcon={<Add />} onClick={handleCreateStory}>
              Create Story
            </Button>
          </Box>
        )}
      </Box>
      <Box css={storyListContainer(theme)}>
        {storiesList.map((story, index) => (
          <RiskStoryCard key={index} story={story} onClick={() => handleStorySelect(story)} />
        ))}
      </Box>
    </Box>
  )
}
export default RiskStoryList
